// extracted by mini-css-extract-plugin
module.exports = {"root":"CaptionDialog__root share-dialog","languageButtons":"CaptionDialog__languageButtons share-buttons","languageButton":"CaptionDialog__languageButton share-button","active":"CaptionDialog__active","title":"CaptionDialog__title share-dialog__title font-size--copy--small font-style--button-1","closeButton":"CaptionDialog__closeButton share-dialog__close-button font-size--extra-small","settingsButton":"CaptionDialog__settingsButton icon icon-Settings"};
    if(module.hot) {
      // 1790535714595
      var cssReload = require("/var/lib/jenkins/workspace/Player_master/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  